import * as yup from "yup";
import { validarCnpj } from "../../core/utils/validarCnpj";
import { validarCpf } from "../../core/utils/validarCpf";

export const criarEstabelecimentoSchema = yup.object().shape({
    tipoPessoa: yup
        .string()
        .oneOf(["PF", "PJ"])
        .required(),
    cnpj: yup
        .string()
        .when("tipoPessoa", {
            is: "PJ",
            then: (schema) =>
                schema
                    .required("O CNPJ é obrigatório")
                    .test("cnpj", "CNPJ inválido", (value) => validarCnpj(value, true)),
            otherwise: (schema) => schema.optional(),
        }),
    cpf: yup
        .string()
        .when("tipoPessoa", {
            is: "PF",
            then: (schema) =>
                schema
                    .required("O CPF é obrigatório")
                    .test("cpf", "CPF inválido", (value) => validarCpf(value, true)),
            otherwise: (schema) => schema.optional(),
        }),
    nomeFantasia: yup.string().required("O nome do estabelecimento é obrigatório"),
    razaoSocial: yup
        .string()
        .when("tipoPessoa", {
            is: "PJ",
            then: (schema) => schema.required("A razão social é obrigatória"),
            otherwise: (schema) => schema.optional(),
        }),
    endereco: yup.object().shape({
        cep: yup.string(),
        rua: yup.string().required("A rua é obrigatória"),
        numero: yup.string().required("O número é obrigatório"),
        complemento: yup.string(),
        bairro: yup.string().required("O bairro é obrigatório"),
        cidade: yup.string().required("A cidade é obrigatória"),
        uf: yup
            .string()
            .required("O estado é obrigatório")
            .min(2, "UF inválida")
            .max(2, "UF inválida"),
    }),
});
